import React from 'react';
import PropTypes from 'prop-types';

import { usePayInPayId, useRegistration } from '@send-data-hooks';
import { useFeature } from '@sendpayments/react-shared/hooks/useFeature';
import { PD_2160_VRN_CREATION } from '@sendpayments/shared-constants/features';
import { ListView } from '@send-legacy-components/Common/ListView';
import { getCurrencyString } from '@sendpayments/js-utils/dist/utils/currency';

const dataSourcePayID = [
  {
    id: 'payID',
    iconType: 'bank',
    header: 'PayID',
    expandable: true,
  },
];

export const BankDetailsPayInPayId = ({ amount, currency, paymentReference }) => {
  const [
    {
      data: { isEnabled: vrnCreationEnabled },
    },
  ] = useFeature({
    feature: PD_2160_VRN_CREATION,
    functionName: 'VRNCreationFunction',
    activeValue: undefined,
    defaultValue: undefined,
  });

  const [{ data: userAccount }] = useRegistration();
  const [payInPayIdDetail, loading] = usePayInPayId({ userAccount });

  return !vrnCreationEnabled && payInPayIdDetail?.payInPayIdStatus === 'Active' && !loading ? (
    <ListView highlight={false} dataSource={dataSourcePayID}>
      <div>
        <div className="small-title">Please pay the settlement payment to Send by using the below details:</div>
        <table className="bank-details">
          <tbody>
            <tr>
              <td>Amount Outstanding</td>
              <td className="info">{getCurrencyString({ amount, currency })}</td>
            </tr>
            <tr>
              <td>PayID</td>
              <td className="info">{payInPayIdDetail.payInPayIdAlias}</td>
            </tr>
            <tr>
              <td>Payment Reference</td>
              <td className="info">{paymentReference}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ListView>
  ) : (
    ''
  );
};

BankDetailsPayInPayId.propTypes = {
  dataSourcePayID: PropTypes.array,
  amount: PropTypes.number,
  currency: PropTypes.string,
  paymentReference: PropTypes.string,
};

BankDetailsPayInPayId.defaultProps = {
  dataSourcePayID: [],
  amount: 0,
  currency: '',
  paymentReference: '',
};
